import { combineReducers } from "redux";
import { overviewReducer, CreativeMappingsListState } from "./overivew";

export type CreativeMappingsState = Readonly<{
    overview: CreativeMappingsListState;
}>;

export const creativeMappingsReducers = combineReducers<CreativeMappingsState>({
    overview: overviewReducer,
});
